import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBrokerBanner } from '../../components/NewbuildingBrokerBanner';
import { useNewbuildingBrokerAnalyticsUser } from '../../hooks/useNewbuildingBrokerAnalyticsUser';
import { getCurrentRegionId } from '../../selectors/getCurrentRegionId';
import { getJsonQuery } from '../../selectors/getJsonQuery';
import { getPageBrokerFlow, getIsNeedSelfEmployedConfirmation } from '../../selectors/newbuildingBroker';
import { trackBannerClick, trackBannerShown } from '../../tracking/newbuilding/broker';
import { TNewbuildingBrokerFlow } from '../../types/newbuildingBroker';
import { NewbuildingBrokerWidgetContext } from '../NewbuildingBrokerWidgetProvider';

export const NewbuildingBrokerBannerContainer = () => {
  const flowType = useSelector(getPageBrokerFlow) as TNewbuildingBrokerFlow;
  const newbuildingRegionId = useSelector(getCurrentRegionId);
  const isSelfEmployed = useSelector(getIsNeedSelfEmployedConfirmation);
  const jsonQuery = useSelector(getJsonQuery);

  const openWidget = React.useContext(NewbuildingBrokerWidgetContext);

  const user = useNewbuildingBrokerAnalyticsUser(flowType);

  const [loading, setLoading] = React.useState(false);

  const handleBannerShown = React.useCallback(() => {
    trackBannerShown(jsonQuery, user);
  }, []);

  const handleButtonClick = React.useCallback(async () => {
    trackBannerClick(jsonQuery, user);

    setLoading(true);

    await openWidget({
      flowType,
      newbuildingId: null,
      newbuildingRegionId,
      houseId: null,
      isSelfEmployed,
      trackingParams: {
        pageType: 'Listing',
        siteType: 'desktop',
        user,
      },
    });

    setLoading(false);
  }, [flowType, jsonQuery, isSelfEmployed, newbuildingRegionId, openWidget, user]);

  return (
    <ActionAfterViewObserver callback={handleBannerShown} triggerOnce>
      <NewbuildingBrokerBanner
        button={
          <Button onClick={handleButtonClick} loading={loading}>
            Хочу продать
          </Button>
        }
      />
    </ActionAfterViewObserver>
  );
};
